//#region src/locale/locales.ts
const locales = [
	{
		code: "en-gb",
		urlCode: "en",
		country: "gb",
		countryName: "United Kingdom",
		language: "en",
		languageName: "English",
		htmlLang: "en-gb",
		default: true,
		isSecondary: false
	},
	{
		code: "da-dk",
		urlCode: "da",
		country: "dk",
		countryName: "Danmark",
		language: "da",
		languageName: "dansk",
		htmlLang: "da-dk",
		default: false,
		isSecondary: false
	},
	{
		code: "de-de",
		urlCode: "de",
		country: "de",
		countryName: "Deutschland",
		language: "de",
		languageName: "Deutsch",
		htmlLang: "de-de",
		default: false,
		isSecondary: false
	},
	{
		code: "es-es",
		urlCode: "es",
		country: "es",
		countryName: "España",
		language: "es",
		languageName: "español",
		htmlLang: "es-es",
		default: false,
		isSecondary: false
	},
	{
		code: "sv-se",
		urlCode: "se",
		country: "se",
		countryName: "Sverige",
		language: "sv",
		languageName: "svenska",
		htmlLang: "sv-se",
		default: false,
		isSecondary: false
	},
	{
		code: "en-ie",
		urlCode: "ie",
		country: "ie",
		countryName: "Ireland",
		language: "en",
		languageName: "English",
		htmlLang: "en-ie",
		default: false,
		isSecondary: false
	},
	{
		code: "fi-fi",
		urlCode: "fi",
		country: "fi",
		countryName: "Suomi",
		language: "fi",
		languageName: "suomi",
		htmlLang: "fi-fi",
		default: false,
		isSecondary: true
	},
	{
		code: "de-at",
		urlCode: "at",
		country: "at",
		countryName: "Österreich",
		language: "de",
		languageName: "Deutsch",
		htmlLang: "de-at",
		default: false,
		isSecondary: true
	},
	{
		code: "fr-be",
		urlCode: "fr-be",
		country: "be",
		countryName: "Belgique",
		language: "fr",
		languageName: "français",
		htmlLang: "fr-be",
		default: false,
		isSecondary: true
	},
	{
		code: "nl-be",
		urlCode: "nl-be",
		country: "be",
		countryName: "België",
		language: "nl",
		languageName: "Nederlands",
		htmlLang: "nl-be",
		default: false,
		isSecondary: true
	},
	{
		code: "fr-fr",
		urlCode: "fr",
		country: "fr",
		countryName: "France",
		language: "fr",
		languageName: "français",
		htmlLang: "fr-fr",
		default: false,
		isSecondary: false
	},
	{
		code: "nl-nl",
		urlCode: "nl",
		country: "nl",
		countryName: "Nederland",
		language: "nl",
		languageName: "Nederlands",
		htmlLang: "nl-nl",
		default: false,
		isSecondary: false
	},
	{
		code: "et-ee",
		urlCode: "ee",
		country: "ee",
		countryName: "Eesti",
		language: "en",
		languageName: "English",
		htmlLang: "en-ee",
		default: false,
		isSecondary: true
	},
	{
		code: "it-it",
		urlCode: "it",
		country: "it",
		countryName: "Italia",
		language: "it",
		languageName: "italiano",
		htmlLang: "it-it",
		default: false,
		isSecondary: true
	},
	{
		code: "pt-pt",
		urlCode: "pt",
		country: "pt",
		countryName: "Portugal",
		language: "pt",
		languageName: "português",
		htmlLang: "pt-pt",
		default: false,
		isSecondary: true
	},
	{
		code: "en-lu",
		urlCode: "lu",
		country: "lu",
		countryName: "Luxembourg",
		language: "en",
		languageName: "English",
		htmlLang: "en-lu",
		default: false,
		isSecondary: true
	},
	{
		code: "no-no",
		urlCode: "no",
		country: "no",
		countryName: "Norge",
		language: "no",
		languageName: "norsk",
		htmlLang: "no-no",
		default: false,
		isSecondary: true
	},
	{
		code: "en-us",
		urlCode: "us",
		country: "us",
		countryName: "United States",
		language: "en",
		languageName: "English",
		htmlLang: "en-us",
		default: false,
		isSecondary: true
	}
];
//#endregion
//#region src/locale/is-supported-locale.ts
const isSupportedLocale = (localeCode) => locales.some((locale) => locale.code === localeCode);
//#endregion
//#region src/locale/get-language-name.ts
const getLanguageName = (languageCode, targetLanguageCode) => {
	return new Intl.DisplayNames(targetLanguageCode || languageCode, { type: "language" }).of(languageCode);
};
//#endregion
//#region src/locale/locale-to-url.ts
const localeCodeToUrl = (localeCode) => {
	const [language, country] = localeCode.toLowerCase().split("-");
	switch (localeCode) {
		case "en-gb":
		case "da-dk": return language;
		case "fr-be":
		case "nl-be": return localeCode;
		default: return country;
	}
};
//#endregion
//#region src/locale/to-astro-i18n-locales.ts
const toAstroI18nLocales = () => locales.map((locale) => ({
	codes: locale.default ? [locale.code, locale.urlCode] : [locale.code],
	path: locale.urlCode
}));
const defaultLocale = locales.find((locale) => locale.default);
if (!defaultLocale) throw new Error("No default locale found in `locales`: expected exactly one locale with `default: true`.");
const defaultLocaleUrlCode = defaultLocale.urlCode;
//#endregion
//#region src/locale/url-to-locale-code.ts
const urlToLocaleCode = (urlCode) => {
	const locale = locales.find((entry) => entry.urlCode === urlCode);
	if (!locale) throw new Error(`No locale for url code "${urlCode}"`);
	return locale.code;
};
//#endregion
export { defaultLocaleUrlCode, getLanguageName, isSupportedLocale, localeCodeToUrl, locales, toAstroI18nLocales, urlToLocaleCode };
